import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ExtraOptions, PreloadAllModules, RouterModule } from '@angular/router';
import { appRoutes } from './app.routing';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { provideFirebaseApp, getApp, initializeApp } from '@angular/fire/app';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { LayoutModule } from './layout/layout.module';
import { environment } from 'src/environments/environment';
import { DialogModule } from 'src/@order/dialogs/dialog.module';
import { MatDialogModule } from '@angular/material/dialog';
// import { AgmCoreModule } from '@agm/core';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { FIREBASE_OPTIONS } from '@angular/fire/compat';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { CommonComponentsModule } from 'src/@order/components/common-components.module';
import { ProgressBarModule } from 'src/@order/components/progress-bar/progress-bar.module';
// import { AgmDirectionModule } from 'agm-direction';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { DataDecryptionIntercaptorService } from 'src/@order/services/data-decryption-intercaptor.service';
import { EncryptioninterceptorService } from 'src/@order/services/encryptioninterceptor.service';
import { OrderSuccessComponent } from './modules/order-success/order-success.component';
import { PixelModule } from '@felipeclopes/ngx-pixel';
import { environmentFlag } from './utils/systemEnums';
import { AffiliateRedirectionComponent } from './modules/auth/affiliate-redirection/affiliate-redirection.component';
import { AfterOrderInterRegionalComponent } from './modules/after-order-inter-regional/after-order-inter-regional.component';
import { GetQrOrderDetailsComponent } from './modules/get-qr-order-details/get-qr-order-details.component';
import { DistributionPartnerComponent } from './modules/distribution-partner/distribution-partner.component';
import { OrderTrackingComponent } from './modules/order-tracking/order-tracking.component';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { ServiceWorkerModule } from '@angular/service-worker';
import { SpecificOrderTrackingComponent } from './modules/specific-order-tracking/specific-order-tracking.component';

// Global Error Handler for Google Maps and other errors
class GlobalErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    // Ignore Google Maps specific errors that are not critical
    if (
      error?.message?.includes('vI') ||
      error?.message?.includes('Google Maps') ||
      error?.message?.includes('loading=async') ||
      error?.stack?.includes('maps.googleapis.com')
    ) {
      console.warn('Google Maps related error (non-critical):', error);
      return;
    }

    // Log other errors normally
    console.error('An error occurred:', error);
  }
}

const routerConfig: ExtraOptions = {
  scrollPositionRestoration: 'enabled',
};

@NgModule({
  declarations: [
    AppComponent,
    OrderSuccessComponent,
    AffiliateRedirectionComponent,
    AfterOrderInterRegionalComponent,
    GetQrOrderDetailsComponent,
    DistributionPartnerComponent,
    OrderTrackingComponent,
    SpecificOrderTrackingComponent,
    // HeavyItemsComponent,
  ],
  imports: [
    CommonModule,
    // PixelModule.forRoot({ enabled: true, pixelId: '503231305864752' }),
    PixelModule.forRoot({ enabled: true, pixelId: '3904784016434343' }),
    BrowserModule,
    DialogModule,
    ProgressBarModule,
    // Layout module
    LayoutModule,
    MatRippleModule,
    MatIconModule,
    MatDialogModule,
    HttpClientModule,
    MatSnackBarModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(appRoutes, routerConfig),
    GooglePlaceModule,
    FormsModule,

    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.serviceWorker,
      registrationStrategy: 'registerWhenStable:30000',
    }),
    // AgmCoreModule.forRoot({
    //   apiKey: environmentFlag == 'prod' ? 'AIzaSyCnWl_m124PuLx2g4cJMEA98cxHvDb7t5k': 'AIzaSyDrl29BNQVeFv93cfa5N6lf2lZ8Bxof2A4',
    //   // apiKey: environmentFlag == 'prod' ? 'AIzaSyBOZI9gwD6_VidQtpzUv4B0IZXGLlUlz1I': 'AIzaSyASDp3E4TsLp6RJCVwNatHYr58PdyJfeHo',
    //   // apiKey: 'AIzaSyDosbgI6M3Iw9abM1cQTvFpOeJI3qpfIEs',
    //   libraries: ['places']
    // }),
    // AgmDirectionModule,

    // MatGoogleMapsAutocompleteModule,

    // firebase
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideFirestore(() => getFirestore()),
    provideAuth(() => getAuth()),
  ],

  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: EncryptioninterceptorService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: DataDecryptionIntercaptorService,
      multi: true,
    },
    {
      provide: FIREBASE_OPTIONS,
      useValue: environment.firebaseConfig,
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
